import axios from "axios";
import authenService from "./authenService";


const axiosInstance = axios.create();
axiosInstance.defaults.timeout = 30000;
axiosInstance.interceptors.request.use(async (config) => {
  const { store } = require("../redux/store");
  //console.log("axios store: ", store);
  if (store) {
    const states = store.getState();
    //console.log("axios states: ", states);
    if (config.headers.Authorization === "Bearer") {
      const _authenService = new authenService();
      let accessToken = states.authenReducer.accessToken;
      const refreshToken = states.authenReducer.refreshToken;
      const accessTokenExp = states.authenReducer.tokenExpire;
      const d1 = new Date();
      const d2 = new Date(accessTokenExp * 1000);
      //console.log("axios d1 ", d1);
      //console.log("axios d2 ", d2);
      if (d2 < d1) {
        accessToken = await _authenService.refreshToken(refreshToken);
      }
      config.headers["Authorization"] = "Bearer " + accessToken;
    }
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    try {
      return response;
    } catch (error) {
      //console.log("axios error: ", error);
      //console.log("axios error response: ", JSON.stringify(response));
      return response;
    }
  },
  (error) =>
    Promise.reject(
      (error.response && error.response.data && error.response.data.errMsg) ||
        (error.response && error.response.data) ||
        "Something went wrong!"
    )
);

export default axiosInstance;
